export default __webpack_public_path__ + "media/zurb/img/events/soapbox/randfishkin-81867704de63e1e87dce408231c2ffdb.png";